import language from "../language/language";
import customers from "../customers/customers";
import flags from "../language/flags";
//console.log("src/reducers/init.js");
let cust = getCustVariable(Number(getQueryVariable("c", 6921)));
let lang = null;
let dftlg = "";
if (!customers[cust][1].c0) {
  dftlg = "nl";
} else {
  dftlg = customers[cust][1].c0;
}
if (!lang) {
  lang = getLangVariable(getQueryVariable("l", dftlg));
}
//console.log("flags:", flags);
// initial store
const initialStore = {
  flags: flags,
  lang: lang,
  cust: cust,
  title: language[lang][1].title,
  task1: language[lang][1].task1,
  task2: language[lang][1].task2,
  tv1: language[lang][1].tv1,
  tv2: language[lang][1].tv2,
  tv3: language[lang][1].tv3,
  tv4: language[lang][1].tv4,
  tv5: language[lang][1].tv5,
  tv6: language[lang][1].tv6,
  tv7: language[lang][1].tv7,
  tv8: language[lang][1].tv8,
  tv9: language[lang][1].tv9,
  tv10: language[lang][1].tv10,
  tv11: language[lang][1].tv11,
  tv12: language[lang][1].tv12,
  tv13: language[lang][1].tv13,
  tv14: language[lang][1].tv14,
  tv15: language[lang][1].tv15,
  tv16: language[lang][1].tv16,
  submit: language[lang][1].submit,
  load1: language[lang][1].load1,
  load2: language[lang][1].load2,
  load3: language[lang][1].load3,
  c1: customers[cust][1].c1,
  c2: customers[cust][1].c2,
  c3: customers[cust][1].c3,
  c4: customers[cust][1].c4,
  c5: customers[cust][1].c5,
  c10: customers[cust][1].c10,
  c11: customers[cust][1].c11,
  c12: customers[cust][1].c12,
  c: getQueryVariable("c", 6921),
  l: getQueryVariable("l", "nl"),
  s: getQueryVariable("s"),
  b: getQueryVariable("b"),
  o: getQueryVariable("o"),
};

// get lang nl=0,en=1,de=2,fr=3
function getLangVariable(lang) {
  switch (lang) {
    case "nl":
      return 0;
    case "en":
      return 1;
    case "de":
      return 2;
    case "fr":
      return 3;
    default:
      return 0;
  }
}

// get cust 1=0,2=1,3=2,4=3
function getCustVariable(cust) {
  const it = customers.keys();
  for (const key of it) {
    if (customers[key][0] === cust) {
      return key;
    }
  }
}

// get URL params
function getQueryVariable(variable, std) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      if (pair[1]) {
        return pair[1];
      }
      return false;
    }
  }
  if (std) {
    return std;
  }
  return false;
}

// REDUCER
export default function initReducer(state = initialStore, action) {
  const evalue = action.evalue;
  //  console.log("action", action);
  let lng = 0;
  switch (evalue) {
    case "NL":
      lng = 0;
      break;
    case "GB":
      lng = 1;
      break;
    case "DE":
      lng = 2;
      break;
    case "FR":
      lng = 3;
      break;
    default:
      lng = 0;
      break;
  }

  switch (action.type) {
    // C H G _ L A N G
    case "CHG_LANG":
      return {
        ...state,
        lang: lng,
        title: language[lng][1].title,
        task1: language[lng][1].task1,
        task2: language[lng][1].task2,
        tv1: language[lng][1].tv1,
        tv2: language[lng][1].tv2,
        tv3: language[lng][1].tv3,
        tv4: language[lng][1].tv4,
        tv5: language[lng][1].tv5,
        tv6: language[lng][1].tv6,
        tv7: language[lng][1].tv7,
        tv8: language[lng][1].tv8,
        tv9: language[lng][1].tv9,
        tv10: language[lng][1].tv10,
        tv11: language[lng][1].tv11,
        tv12: language[lng][1].tv12,
        tv13: language[lng][1].tv13,
        tv14: language[lng][1].tv14,
        tv15: language[lng][1].tv15,
        tv16: language[lng][1].tv16,
        submit: language[lng][1].submit,
        load1: language[lng][1].load1,
        load2: language[lng][1].load2,
        load3: language[lng][1].load3,
      };
    // D E F A U L T
    default:
      return { ...state };
  }
}
